package com.ijoin.data.model

import kotlinx.serialization.Serializable

@Serializable
data class UserProfile(
    val user: User,
    val followersCount: Long = 0,
    val followingCount: Long = 0,
    val following: Boolean = false,
    val self: Boolean = false,
    val upcomingEvents: List<Event> = emptyList(),
    val archivedEvents: List<Event> = emptyList(),
    val followingPreview: List<User> = emptyList(),
    val currentBalance: MoneyAmount? = null
)

@Serializable
data class UserFollowState(
    val followersCount: Long,
    val followingCount: Long,
    val following: Boolean
)
